<template>
  <v-container id="page-admin-list">
    <div class="page-title">{{$route.name}}</div>

    <v-row>
      <v-spacer></v-spacer>
      <v-col class="d-flex justify-end">
        <span>
          <v-select
            v-model="filterItem"
            :items="['이름','아이디','센터']"
            label=""
            :menu-props="{ auto: true, overflowY: true}"
            outlined dense hide-details
          ></v-select>
        </span>
        <span class="ml-3">
          <v-text-field
            v-model="searchKeyword"
            label="관리자 검색"
            append-icon="search"
            dense hide-details
            @click:append="onSearchByKeyword"
            @keyup.enter="onSearchByKeyword"
            maxlength="32"
          ></v-text-field>
        </span>
        <span class="ml-3">
          <c-btn color="blue" outlined iconName="add" :disabled="registerDisableOpt" @click="adminDialog = true">계정등록</c-btn>
        </span>
      </v-col>
    </v-row>

    <c-table
      :headers="adminTableHeaders"
      item-key="id"
      :items="adminList"
    >
      <template #action="{ item }">
        <c-btn icon iconName="edit" @click="onEditInfo(item)" :disabled="userInfo.role ==='user' || userInfo.role ==='RM' && item.loginId !== userInfo.loginId ? true : false"></c-btn>
        <c-btn icon iconName="delete" :class="deleteDisplayOpt" @click="ondeleteAdmin(item.id)"></c-btn>
      </template>
    </c-table>

    <admin-c-u-dialog
      :open.sync="adminDialog"
      :adminFormData="adminFormData"
      @reqAddAdmin="reqAddAdmin"
      @reqUpdateAdmin="reqUpdateAdmin"
    />
  </v-container>
</template>
<script>
  import AdminCUDialog from "./AdminCUDialog";

  export default {
    components: {
      AdminCUDialog
    },
    data: () => ({
      adminDialog: false,

      adminTableHeaders: [
        {
          text: '센터',
          value: 'centerName',
          align: 'center',
          sortable: true,
        },
        {
          text: '아이디',
          value: 'loginId',
          align: 'center',
          sortable: true,
        },
        {
          text: '이름',
          value: 'name',
          align: 'center',
          sortable: true,
        },
        {
          text: '연락처',
          value: 'extension',
          align: 'center',
          sortable: false,
        },
        {
          text: '',
          value: 'action',
          align: 'center',
          sortable: false,
        },
      ],
      adminList: [],

      adminFormData: null,
      userInfo: null,

      filterItem:'이름',
      searchKeyword:'',

    }),
    watch: {
      adminDialog(value) {
        if (!value) this.adminFormData = null;
      },
      searchKeyword() {
        if(this.searchKeyword.length < 1) {
          this.reqGetAdminList();
        }
      },
      filterItem() {
        this.searchKeyword = '';
        this.reqGetAdminList();

        // this.onSearchByKeyword();
      }
    },
    computed:{
      registerDisableOpt() {
        if(this.userInfo){
          return this.userInfo.role === 'user';
        }
      },
      deleteDisplayOpt() {
        if(this.userInfo && this.userInfo.role !== 'SA') {
          return 'd-none'
        }
      },
    },
    methods: {
      async reqGetAdminList() {
        try {
          this.userInfo = this.$store.state.userInfo;
          const res = await this.$api.getAdminListByRole(this.$store.state.service);

          let result = [];
          for(let i=0; i< res.data.length; i++) {
              let data = {};
              data = res.data[i];
              data['id'] = res.data[i].id;
              data['centerName'] = res.data[i].centerId.centerName;

              result.push(data);
            }
          this.adminList = result;

        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqGetAdminList'});
        }
      },

      async reqAddAdmin(data) {
        try {
          const res = await this.$api.addAdmin(data);
          this.adminDialog = false;
          this.reqGetAdminList();
          this.$store.commit('snackbar', {color: 'blue', msg: '계정이 추가되었습니다.'});
        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqAddAdmin'});
        }

      },

      async reqUpdateAdmin(data) {
        try {
          const res = await this.$api.updateAdmin(data);
          this.adminDialog = false;
          this.reqGetAdminList();
          this.$store.commit('snackbar', {color: 'blue', msg: '계정이 수정되었습니다.'});

        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqUpdateAdmin'});
        }
      },

      onEditInfo(data) {
        this.adminFormData = {
          id: data.id,
          centerId: data.centerId,
          loginId: data.loginId,
          password: data.password,
          name: data.name,
          extension: data.extension,
          authority : data.role,
          menuRole : data.menuRole,
        };
        this.adminDialog = true;
      },
      ondeleteAdmin(id) {
        this.$store.commit('alert',
          {
            open: true, persistent: true, msg: "계정을 삭제하시겠습니까?",
            confirm: true, callBack: () => {
              this.reqDeleteAdminById(id);
            }
          });
      },
      async reqDeleteAdminById(id) {
        try {
          await this.$api.deleteAdmin(id);
          await this.reqGetAdminList();
          this.$store.commit('snackbar', {color: 'blue', msg: '계정이 삭제되었습니다.'});
        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqDeleteAdminById'});
        }
      },
      onSearchByKeyword() {

        const tableData = this.adminList.filter(item => {
          if(this.filterItem === '센터') {
            return item.centerName.indexOf(this.searchKeyword) < 0 ? false : true
          } else if(this.filterItem === '아이디') {
            return item.loginId.indexOf(this.searchKeyword) < 0 ? false : true;
          } else if(this.filterItem === '이름') {
            return item.name.indexOf(this.searchKeyword) < 0 ? false : true;
          }
        });

        this.adminList = tableData;
      },

    },
    activated() {
      this.reqGetAdminList();
    }
  }
</script>


<style>
</style>
